import { LottiePlayer, Svg } from '@repo/ui';

import ErrorBaseView from '@/components/tax-refund/common/view/ErrorView/ErrorBaseView';
import { ErrorBaseViewController } from '@/lib/types/layout.ts';

interface Props {
  onPrimaryButtonClick: () => void;
}

export const HometaxLookupUnavailableTimeError = ({ onPrimaryButtonClick }: Props) => {
  const errorBaseViewController: ErrorBaseViewController = {
    graphic: <Svg src="icg_clock_md.svg" width={80} height={80} />,
    title: '아침 6시 이후에\n다시 조회해주세요',
    description: '매일 밤 0시부터 아침 6시까지\n홈택스 점검으로 환급액 조회가 어려워요.',
    primaryButtonText: '홈으로',
    onPrimaryButtonClick: onPrimaryButtonClick,
    primaryButtonVariant: 'tonal-secondary'
  };

  return <ErrorBaseView viewController={errorBaseViewController} />;
};

export const HometaxBizMessageUnavailableTimeError = ({ requestType }: { requestType: string }) => {
  const hometaxStartTime = requestType === 'recollect' ? 9 : 6;

  const errorBaseViewController: ErrorBaseViewController = {
    graphic: <Svg src="icg_clock_md.svg" width={88} height={88} />,
    title: `아침 ${hometaxStartTime}시 이후에\n다시 진행해주세요`,
    description: `매일 밤 0시부터 아침 ${hometaxStartTime}시까지는\n${requestType === 'recollect' ? '신고 자료' : '홈택스 점검으로'} 진행이 어려워요.`
  };

  return <ErrorBaseView viewController={errorBaseViewController} />;
};

export const HometaxMaintenanceNotificationError = ({
  agreedMarketing,
  onNotificationButtonClick
}: {
  agreedMarketing: boolean;
  onNotificationButtonClick: () => void;
}) => {
  const errorBaseViewController: ErrorBaseViewController = {
    graphic: <LottiePlayer src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/lotties/ani_bell-dot.json`} className={'w-[88px] h-[88px]'} />,
    title: '홈택스 점검(오전 0시~6시)으로\n환급금 조회가 어려워요',
    description: agreedMarketing ? '점검이 끝나면 카카오톡 알림톡으로\n빠르게 알려드릴게요.' : '조회할 수 있을 때 알려드릴 수 있어요.\n알림을 받으시겠어요?',
    primaryButtonText: agreedMarketing ? undefined : '알림받기 설정',
    onPrimaryButtonClick: agreedMarketing ? undefined : onNotificationButtonClick
  };

  return <ErrorBaseView viewController={errorBaseViewController} />;
};
